module.exports = __webpack_public_path__ + "static/media/dropdownForCollapse.65e2ec26.svg";